import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";
import { setToken } from "../../features/userSlice";

export const AuthApi = createApi({
  reducerPath: "AuthApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["AUTH"],
  endpoints: (build) => ({
    login: build.mutation({
      query: (data) => ({
        url: "/auth/login",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          console.log(data);

          if (data && data?.data?.token) {
            dispatch(setToken(data?.data?.token));
          }
        } catch (error) {}
      },
      invalidatesTags: ["AUTH"],
    }),

    register: build.mutation({
      query: (data) => ({
        url: `/auth/register`,
        method: "POST",
        body: data,
      }),
    }),

    getMe: build.query({
      query: () => ({
        url: `/auth/me`,
        method: "GET",
      }),
      providesTags: ["AUTH"],
    }),

    getAllUsers: build.query({
      query: ({ page = 1, limit = 20, role, isActive } = {}) => ({
        url: `/auth/users`,
        method: "GET",
        params: {
          page,
          limit,
          role,
          isActive,
        },
      }),
      providesTags: ["AUTH"],
    }),

    createUser: build.mutation({
      query: (data) => ({
        url: `/auth/users`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["AUTH"],
    }),

    updateUser: build.mutation({
      query: ({ userId, ...data }) => ({
        url: `/auth/users/${userId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["AUTH"],
    }),

    toggleUserStatus: build.mutation({
      query: (userId) => ({
        url: `/auth/users/${userId}/toggle-status`,
        method: "PATCH",
      }),
      invalidatesTags: ["AUTH"],
    }),

    deleteUser: build.mutation({
      query: (userId) => ({
        url: `/auth/users/${userId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["AUTH"],
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useGetMeQuery,
  useGetAllUsersQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useToggleUserStatusMutation,
  useDeleteUserMutation,
} = AuthApi;
